import { useSelector } from 'react-redux';

import { useDispatchOnMount } from '../../../hooks';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import { fetchPackageSummary } from '../../../redux/packageInventory/actions';
import Loader from '../../generic/Loader';
import Tooltip from '../../generic/Tooltip';

import styles from './PackageCount.module.less';

/**
 * Component to show the total package count.
 * On hover, a tooltip displays the last cache date.
 */
const PackageCount = () => {
  useDispatchOnMount(fetchPackageSummary);
  const packageSummary = useSelector(PackageInventoryStore.selectors.getPackageSummary);
  const { count, lastCacheDate } = packageSummary;
  const asyncStatus = useSelector(PackageInventoryStore.selectors.getAsyncStatusGetPackageSummary);
  const packageCountContent = asyncStatus.isLoading ? (
    <div className="margin-top-sm">
      <Loader size={30} />
    </div>
  ) : (
    <div className={styles.count}>{count}</div>
  );

  return (
    <Tooltip id="last-cache-date" tooltip={lastCacheDate}>
      <div className={styles.container}>
        <div className={styles.label}>Packages</div>
        {packageCountContent}
      </div>
    </Tooltip>
  );
};

export default PackageCount;
